const _ = require('lodash');
const angular = require('angular');
let _$parse = undefined;


function setHeading(index) {
	const newSlide = this.slides.eq(index);
	const compiled = _.template(newSlide.attr('data-title'));
	this.heading = compiled({ current: index + 1, count: this.count });
}

function setSlideToBeActive(index) {
	const activeSlide = this.slides.eq(index);
	_.forEach(this.slides, (slide) => {
		angular.element(slide).removeClass('slide-active');
	});

	activeSlide.addClass('slide-active');
}

function navigate(nextIndex, currentIndex) {
	const slide = this.slides.eq(currentIndex);
	const canLeaveFunc = slide.attr('data-can-leave');
	const isMovingForward = (nextIndex > currentIndex);
	let canProceed = true;

	if (canLeaveFunc && isMovingForward) {
		canProceed = _$parse(canLeaveFunc)(this._scope);
	}

	if (canProceed) {
		this._form.$setUntouched();// clear any previous errors
		this._form.$setPristine();
		setHeading.call(this, nextIndex);
		setSlideToBeActive.call(this, nextIndex);
		this.current = nextIndex;
		return;
	}

	this._form.$setSubmitted(); // show errors to user
}

class FormWizard {

	constructor(form, scope, slides) {
		const vm = this;
		vm._form = form;
		vm._scope = scope;
		form.$setUntouched(); // clear any previous errors
		form.$setPristine(); // set form to a new state
		vm.current = 0;
		vm.slides = slides;
		vm.count = slides.length - 1;
		vm.setSlideToBeActive = setSlideToBeActive;
		setHeading.call(vm, this.current);
		setSlideToBeActive.call(vm, this.current);
	}

	hasNextBtn() {
		const slide = this.slides.eq(this.current);
		if (!!slide.attr('data-next-hidden')) {
			return false;
		}
		return this.current < this.count;
	}

	hasPreviousBtn() {

		const slide = this.slides.eq(this.current);

		if (!!slide.attr('data-previous-hidden')) {
			return false;
		}

		return this.current > 0;
	}

	hasNext() {
		return this.current < this.count;
	}

	hasPrevious() {
		return this.current > 0;
	}

	nextId() {
		return (this.hasNext()) ? this.current + 1 : this.current;
	}

	previousId() {
		return (this.hasPrevious()) ? this.current - 1 : this.current;
	}

	moveNext() {
		navigate.call(this, this.nextId(), this.current);
	}

	movePrevious() {
		navigate.call(this, this.previousId(), this.current);
	}

	isLastSlide() {
		return this.current === this.count;
	}

	isFirstSlide() {
		return this.current === 0;
	}

	isCurrentSlide(slide) {
		const currentSide = this.slides.eq(this.current);
		return slide.attr('data-slide-index') === currentSide.attr('data-slide-index');
	}
}


function CreateFormWizard($parse) {
    _$parse = $parse;
}

CreateFormWizard.prototype.build = function (form, scope, slides) {
	return new FormWizard(form, scope, slides);
};

module.exports = CreateFormWizard;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/customer-reviews/post-review/create-form-wizard.js
 **/